import {
  OnRampPaymentResponse,
  OnRampPaymentResponseStatusEnum,
  PaginationOrderEnum,
} from "@src/shared/api/generated"
import { CollectionMockResolver } from "@src/shared/classes/Collection/collectionMocks"

export const ON_RAMP_PAYMENTS_MOCK_KEY = "onRampPayments"

type OnRampPaymentsMockRequest = {
  date?: {
    dateFrom?: string
    dateTo?: string
  }
  order?: "asc" | "desc"
  page?: number
  projectId?: string
  status?: OnRampPaymentResponseStatusEnum
}

const onRampPaymentsMock: OnRampPaymentResponse[] = [
  {
    amount: "125.48",
    callback_url: "https://merchant.example.com/on-ramp/callback",
    created_at: "2026-07-29T09:12:24Z",
    customer: {
      email: "anna.kovalenko@example.com",
      first_name: "Anna",
      last_name: "Kovalenko",
    },
    external_id: "or_ext_100245",
    fiat_amount: "125.48",
    fiat_symbol: "EUR",
    id: "orpay_8f7d58d1bc2a4b60a9d2",
    network: "tron",
    project_id: "29052d7641f64c6bbe5b0",
    return_url: "https://merchant.example.com/on-ramp/return",
    status: OnRampPaymentResponseStatusEnum.Completed,
    symbol: "USDT",
  },
  {
    amount: "50.00",
    callback_url: "https://merchant.example.com/on-ramp/callback",
    created_at: "2026-07-28T14:47:02Z",
    customer: {
      email: "mark.hughes@example.com",
      first_name: "Mark",
      last_name: "Hughes",
    },
    external_id: "or_ext_100244",
    fiat_amount: "50.00",
    fiat_symbol: "USD",
    id: "orpay_3a7c21e90a914f8b8176",
    network: "ethereum",
    project_id: "1654d77f78f34862f335e",
    return_url: "https://merchant.example.com/on-ramp/return",
    status: OnRampPaymentResponseStatusEnum.Processing,
    symbol: "USDC",
  },
  {
    amount: "349.99",
    callback_url: "https://merchant.example.com/on-ramp/callback",
    created_at: "2026-07-27T19:05:55Z",
    customer: {
      email: "olga.morozova@example.com",
      first_name: "Olga",
      last_name: "Morozova",
    },
    error: {
      code: 1421,
      message: "Risk control declined operation",
    },
    external_id: "or_ext_100243",
    fiat_amount: "349.99",
    fiat_symbol: "EUR",
    id: "orpay_6e9937f2a8624a66bd71",
    network: "polygon",
    project_id: "5a080ad8d3f044a327ab",
    return_url: "https://merchant.example.com/on-ramp/return",
    status: OnRampPaymentResponseStatusEnum.Failed,
    symbol: "USDT",
  },
  {
    amount: "25.00",
    callback_url: "https://merchant.example.com/on-ramp/callback",
    created_at: "2026-07-26T11:31:18Z",
    customer: {
      email: "david.lee@example.com",
      first_name: "David",
      last_name: "Lee",
    },
    external_id: "or_ext_100242",
    fiat_amount: "25.00",
    fiat_symbol: "GBP",
    id: "orpay_a4dd42f71e39447c8cd9",
    network: "bsc",
    project_id: "29052d7641f64c6bbe5b0",
    return_url: "https://merchant.example.com/on-ramp/return",
    status: OnRampPaymentResponseStatusEnum.Pending,
    symbol: "USDT",
  },
]

export const getOnRampPaymentsMock: CollectionMockResolver<
  OnRampPaymentResponse
> = (req, { calcOffset, pageSize }) => {
  const {
    date,
    order = "desc",
    page = 0,
    projectId,
    status,
  } = req as OnRampPaymentsMockRequest

  const offset = calcOffset(page)

  const filteredItems = onRampPaymentsMock
    .filter((item) => !status || item.status === status)
    .filter((item) => !projectId || item.project_id?.includes(projectId))
    .filter((item) => {
      if (!date?.dateFrom && !date?.dateTo) return true

      if (!item.created_at) return false

      const createdAt = new Date(item.created_at).getTime()
      const dateFrom = date.dateFrom ? new Date(date.dateFrom).getTime() : null
      const dateTo = date.dateTo ? new Date(date.dateTo).getTime() : null

      return (
        (dateFrom === null || createdAt >= dateFrom) &&
        (dateTo === null || createdAt <= dateTo)
      )
    })
    .sort((a, b) => {
      const firstCreatedAt = new Date(a.created_at ?? 0).getTime()
      const secondCreatedAt = new Date(b.created_at ?? 0).getTime()

      return order === "asc"
        ? firstCreatedAt - secondCreatedAt
        : secondCreatedAt - firstCreatedAt
    })

  return {
    data: filteredItems.slice(offset, offset + pageSize),
    pagination: {
      limit: pageSize,
      offset,
      order:
        order === "asc" ? PaginationOrderEnum.Asc : PaginationOrderEnum.Desc,
      total: filteredItems.length,
    },
  }
}
